
import { Component, Vue, Prop } from 'vue-property-decorator';
import { getCheckList, delCheck, addEventCheck, editorEventCheck } from '@/api/orderPolling';
import { UserModule } from '@/store/modules/user';

@Component({
  name: 'OrderPollingCheck',
  components: {

  }
})
export default class extends Vue {
  created() {
    this.getCheckList();
  }
  private formSearch = {
    name: ''
  }

  private dialogCheckItemsVisible = false
  private formCheck: any = {
    name: '',
    explain: '',
    unit: ''
  }
  private isEdit = false
  private checkTitle = '添加检查项'
  private checkListItem: any = [{
    name: '状态',
    radio: -1,
    isDiagonal: false,
    configUnusual: false

  }, {
    name: '描述',
    radio: -1,
    isDiagonal: true,
    configUnusual: false
  }, {
    name: '当前值',
    radio: -1,
    isDiagonal: true,
    configUnusual: false
  }, {
    name: '照片',
    radio: -1,
    isDiagonal: true,
    configUnusual: false
  }]

  private tableData = []
  private multipleSelection = []
  private pagination = {
    total: 0,
    page: 1,
    size: 10
  }

  private getCheckList() {
    let _this = this;
    let listQuery:any = {};
    listQuery.user_id = UserModule.getUserId;
    listQuery.company_id = UserModule.getCompanyId;
    listQuery.page = this.pagination.page;
    listQuery.size = this.pagination.size;
    listQuery.check_name = this.formSearch.name;
    getCheckList(listQuery).then(res => {
      if (res.data) {
        _this.pagination.total = res.data.count;
        _this.tableData = res.data.list;
      } else {
        _this.pagination.total = 0
        _this.tableData = [];
      }
    }).catch(err => {
      _this.pagination.total = 0
      _this.tableData = [];
      let msg = err.msg;
    });
  }
  private search() {
    this.pagination.page = 1;
    this.getCheckList();
  }
  private reset() {
    this.formSearch = { name: '' };
    this.pagination.page = 1;
    this.getCheckList();
  }
  private tableSelectionChange(val: any) {
    this.multipleSelection = val;
  }
  private checkHandle(edit: boolean, val: any) {
    this.dialogCheckItemsVisible = true;
    this.isEdit = edit;
    if (val !== null) {
      this.checkTitle = '编辑检查项';
      this.checkListItem[0].radio = parseInt(val.state_config);
      this.checkListItem[1].radio = parseInt(val.text_config);
      this.checkListItem[2].radio = parseInt(val.value_config);
      this.checkListItem[3].radio = parseInt(val.image_config);
      this.checkListItem[1].configUnusual = parseInt(val.text_config_abnormal_is_required) === 1;
      this.checkListItem[2].configUnusual = parseInt(val.value_config_abnormal_is_required) === 1;
      this.checkListItem[3].configUnusual = parseInt(val.image_config_abnormal_is_required) === 1;

      this.formCheck = {
        name: val.name,
        explain: val.statement,
        unit: val.unit,
        id: val.id
      };
    } else {
      this.formCheck = {
        name: '',
        explain: '',
        unit: ''
      };
      this.checkListItem = [{
        name: '状态',
        radio: -1,
        isDiagonal: false,
        configUnusual: false

      }, {
        name: '描述',
        radio: -1,
        isDiagonal: true,
        configUnusual: false
      }, {
        name: '当前值',
        radio: -1,
        isDiagonal: true,
        configUnusual: false
      }, {
        name: '照片',
        radio: -1,
        isDiagonal: true,
        configUnusual: false
      }];
    }
  }
  private finishHandl() {
    if (!this.formCheck.name) {
      this.showErrorMsg('请输入检查项名称');
      return;
    }
    if (this.formCheck.name.length > 30) {
      this.showErrorMsg('请输入1-30位检查项名称');
      return;
    }
    let arr = this.checkListItem.filter((item:any) => {
      return item.radio !== -1;
    });
    if (!arr || arr.length < 1) {
      this.showErrorMsg('请选择属性');
      return;
    }
    let state = this.checkListItem[0];
    let text = this.checkListItem[1];
    let value = this.checkListItem[2];
    let image = this.checkListItem[3];

    let pamars:any = {};
    pamars.user_id = UserModule.getUserId;
    pamars.company_id = UserModule.getCompanyId;
    pamars.user_name = UserModule.getUserName;
    pamars.company_name = UserModule.getCompanyName;
    pamars.state_config = parseInt(state.radio) === -1 ? 0 : state.radio;
    pamars.text_config = parseInt(text.radio) === -1 ? 0 : text.radio;
    pamars.value_config = parseInt(value.radio) === -1 ? 0 : value.radio;
    pamars.image_config = parseInt(image.radio) === -1 ? 0 : image.radio;

    pamars.text_config_abnormal_is_required = text.configUnusual && parseInt(pamars.text_config) == 2 ? 1 : 0;
    pamars.value_config_abnormal_is_required = value.configUnusual && parseInt(pamars.value_config) == 2 ? 1 : 0;
    pamars.image_config_abnormal_is_required = image.configUnusual && parseInt(pamars.image_config) == 2 ? 1 : 0;

    pamars.name = this.formCheck.name;
    pamars.statement = this.formCheck.explain;
    pamars.unit = this.formCheck.unit;
    if (this.isEdit) {
      pamars.check_id = this.formCheck.id;
      editorEventCheck(pamars).then((res:any) => {
        this.showSecussMsg(res.msg);
        this.dialogCheckItemsVisible = false;
        this.pagination.page = 1;
        this.getCheckList();
      }).catch(err => {
        this.showErrorMsg(err.msg);
      });
    } else {
      addEventCheck(pamars).then((res:any) => {
        this.showSecussMsg(res.msg);
        this.dialogCheckItemsVisible = false;
        this.pagination.page = 1;
        this.getCheckList();
      }).catch(err => {
        this.showErrorMsg(err.msg);
      });
    }
  }
  private groupDelete() {
    if (this.multipleSelection.length === 0) {
      this.showErrorMsg('请选择需要删除的检查项');
      return;
    }
    let checkIds = '';
    this.multipleSelection.forEach((ss:any) => {
      checkIds = checkIds + ss.id + ',';
    });
    this.$confirm('确定批量删除检查项?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      this.delCheck(checkIds);
    }).catch(() => {

    });
  }
  private checkDelete(row:any) {
    this.$confirm('确定删除此检查项?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      let checkIds = row.id;
      this.delCheck(checkIds);
    }).catch(() => {

    });
  }
  private delCheck(checkIds:any) {
    let listQuery:any = {};
    listQuery.user_id = UserModule.getUserId;
    listQuery.company_id = UserModule.getCompanyId;
    listQuery.check_ids = checkIds;
    delCheck(listQuery).then((res:any) => {
      this.showSecussMsg(res.msg);
      this.pagination.page = 1;
      this.getCheckList();
    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }
  private handlePageSizeChange(size: number) {
    this.pagination.page = 1;
    this.pagination.size = size;
    this.getCheckList();
  }
  private handleCurrentChange(page:number) {
    this.pagination.page = page;
    this.getCheckList();
  }

  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
  private showSecussMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'success'
    });
  }
}
